import { render, staticRenderFns } from "./CRUDClassificacoesViagens.vue?vue&type=template&id=46296b84&"
import script from "./CRUDClassificacoesViagens.vue?vue&type=script&lang=js&"
export * from "./CRUDClassificacoesViagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports